import React from "react";

import { Box } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

interface Props {
  step: number;
}

const Header: React.FC<Props> = ({ step }) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box>
        <Box
          fontSize={28}
          fontWeight={700}
          lineHeight="18px"
          letterSpacing={-0.5}
          color={colors.dark}
          marginBottom={4}
        >
          Register
        </Box>
        <Box
          fontSize={14}
          lineHeight={1}
          fontWeight={600}
          letterSpacing={-0.5}
          color={colors.grey}
        >
          Create a new account and continue with us
        </Box>
      </Box>
      <Box
        fontSize={18}
        lineHeight={1}
        fontWeight={600}
        letterSpacing={-0.5}
        color={colors.dark}
      >
        {step}/4
      </Box>
    </Box>
  );
};

export default Header;
